import { GET_CURRENCY } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_CURRENCY:
            return action.payload;
        default:
            return state;
    }
}
